import React from 'react';
import { HashLink } from 'react-router-hash-link';
import ThemeToggler from "./ThemeToggler";

const NavLinks = () => {
    return (
        <>
        <div className='flex lg:flex-row flex-col '>

            <HashLink className="px-4 py-2 md:px-5 font-bold lg:font-extrabold text-[#b54a73]  hover:text-[#eda2bf]" smooth to="/#about">
                About
            </HashLink>
            <HashLink className="px-4 py-2 md:px-5 font-bold lg:font-extrabold text-[#b54a73]  hover:text-[#eda2bf]" smooth to="/#certification">
                Certification
            </HashLink>
            <HashLink className="px-4 py-2 md:px-5 font-bold lg:font-extrabold text-[#b54a73]  hover:text-[#eda2bf]" smooth to="/#portfolio">
                Portfolio
            </HashLink>
            <HashLink className="px-4 py-2 md:px-5 font-bold lg:font-extrabold text-[#b54a73]  hover:text-[#eda2bf]" smooth to="/#contact">
                Contact 
            </HashLink>
            <span className="px-4 py-2 flex md:px-5"> <ThemeToggler /></span>
            </div>
        </>
    )
}

export default NavLinks;
